import { environment } from "src/environments/environment";

export const API_ROUTES = {
    ACCOUNT: {
        login: `${environment.apiUrl}v1/client/login`,
        forgetPassword: `${environment.apiUrl}v1/client/forgetPassword`,
        resetPassword: `${environment.apiUrl}v1/client/resetPassword`,
        verifyEmail: `${environment.apiUrl}v1/client/emailVerification`,
        viewProfile: `${environment.apiUrl}v1/client/viewProfile`,
        changePassword: `${environment.apiUrl}v1/client/changePassword`,
        editProfile: `${environment.apiUrl}v1/client/update`,
        loginAsSuperAdmin: `${environment.apiUrl}v1/client/loginAsSuperAdmin`,
        resendVerificationLink: `${environment.apiUrl}v1/client/resendVerificationLink`,
        unsubscribe: `${environment.apiUrl}v1/customers/unsubscribeEmail`,
        pushNotification: `${environment.apiUrl}v1/client/pushNotification`,
        makePayment: `${environment.apiUrl}v1/client/seprateValorCharge`,
        separatePayHistory: `${environment.apiUrl}v1/subscriptions/seprateValorPayments`,
        uploadImage: `${environment.apiUrl}v1/videos/uploadImages`,
        deleteImage: `${environment.apiUrl}v1/videos/deleteImages`,
        notifyEmail: `${environment.apiUrl}v1/client/notifyEmail`
    },
    TASK: {
        getTask: `${environment.apiUrl}v1/tasks/getTasks`,
        createTask: `${environment.apiUrl}v1/tasks/createTask`,
        editTask: `${environment.apiUrl}v1/tasks/updateTask`,
    },
    EMPLOYEE: {
        getEmployee: `${environment.apiUrl}v1/employees/employees`,
        availableTechnician: `${environment.apiUrl}v1/employees/availableTechnician`,
        getEmployeeBySkill: `${environment.apiUrl}v1/employees/empListBySkill`,
        getEmployeeById: `${environment.apiUrl}v1/employees/employeeDetails`,
        deleteEmployee: `${environment.apiUrl}v1/employees/delete`,
        blockEmployee: `${environment.apiUrl}v1/employees/block`,
        addNote: `${environment.apiUrl}v1/employees/addNotes`,
        addFiles: `${environment.apiUrl}v1/employees/addFiles`,
        deleteFile: `${environment.apiUrl}v1/employees/deleteFiles`,
        editEmployee: `${environment.apiUrl}v1/employees/editEmployee`,
        addEmployee: `${environment.apiUrl}v1/employees/invite`,
        empService: `${environment.apiUrl}v1/employees/empService`,
        empArchive: `${environment.apiUrl}v1/employees/getArchiveList`,
        empRestore: `${environment.apiUrl}v1/employees/restore`,
        upload: `${environment.apiUrl}v1/employees/bulkUpload`,
        getTimeSlotForEmployee: `${environment.apiUrl}v1/employees/timeSlotForEmployee`,
        empListForReassignEvents: `${environment.apiUrl}v1/employees/empListForReassignEvents`,
        employeeChatList: `${environment.apiUrl}v1/client/teamChatList`,
        createChatGroup: `${environment.apiUrl}v1/client/createTeamChatGroup`,
        hireDate: `${environment.apiUrl}v1/employees/setEmpHireDate`,
        permaDel: `${environment.apiUrl}v1/employees/deleteEmployeeFromArchive`
    },
    OPPORTUNITY: {
        getOppCount: `${environment.apiUrl}v1/dashboard/opportunityCount`,
        getOppList: `${environment.apiUrl}v1/opportunity/oppList`,
        addOpp: `${environment.apiUrl}v1/opportunity/createOpportunity`,
        editOpp: `${environment.apiUrl}v1/opportunity/editOpp`,
        deleteOpp: `${environment.apiUrl}v1/opportunity/deleteOpportunity`,
        deleteNote: `${environment.apiUrl}v1/opportunity/deleteNotes`,
        addNote: `${environment.apiUrl}v1/opportunity/addNotes`,
        editNote: `${environment.apiUrl}v1/opportunity/updateNote`,
        addFiles: `${environment.apiUrl}v1/opportunity/addFiles`,
        addReminder: `${environment.apiUrl}v1/opportunity/addReminder`,
        getDetail: `${environment.apiUrl}v1/opportunity/oppDetails`,
        updateOpp: `${environment.apiUrl}v1/opportunity/updateOpportunityAndEvent`,
        addEstimate: `${environment.apiUrl}v1/opportunity/addEstimate`,
        addInspection: `${environment.apiUrl}v1/opportunity/addInspectionItems`,
        updateEstimate: `${environment.apiUrl}v1/opportunity/updateEstimate`,
        updateInspection: `${environment.apiUrl}v1/opportunity/updateInspectionItem`,
        deleteEstimate: `${environment.apiUrl}v1/opportunity/deleteEstimate`,
        deleteInspection: `${environment.apiUrl}v1/opportunity/deleteInspectionItem`,
        approveEstimates: `${environment.apiUrl}v1/opportunity/approveEstimates`,
        sendInspection: `${environment.apiUrl}v1/opportunity/sendInspection`,
        inRoute: `${environment.apiUrl}v1/opportunity/inRoute`,
        addPayment: `${environment.apiUrl}v1/opportunity/addPayments`,
        getJobDetail: `${environment.apiUrl}v1/opportunity/jobDetails`,
        editJob: `${environment.apiUrl}v1/opportunity/editJob`,
        deleteJob: `${environment.apiUrl}v1/opportunity/deleteJob`,
        deleteFile: `${environment.apiUrl}v1/opportunity/deleteFiles`,
        deleteReminder: `${environment.apiUrl}v1/opportunity/deleteReminder`,
        addExpense: `${environment.apiUrl}v1/opportunity/addExpense`,
        updateExpense: `${environment.apiUrl}v1/opportunity/editExpense`,
        deleteExpense: `${environment.apiUrl}v1/opportunity/deleteExpense`,
        addQc: `${environment.apiUrl}v1/opportunity/addQcNotes`,
        deleteQc: `${environment.apiUrl}v1/opportunity/deleteQCNotes`,
        getHistory: `${environment.apiUrl}v1/opportunity/activityLogs`,
        updateWorkOrder: `${environment.apiUrl}v1/opportunity/updateWorkOrder`,
        previewWorkOrder: `${environment.apiUrl}v1/opportunity/previewWorkOrder`,
        previewInspection: `${environment.apiUrl}v1/opportunity/previewInspection`,
        reopen: `${environment.apiUrl}v1/opportunity/reopen`,
        appendForm: `${environment.apiUrl}v1/opportunity/appendForm`,
        detachForm: `${environment.apiUrl}v1/opportunity/deattachForm`,
        populateForm: `${environment.apiUrl}v1/dynamicForms/populateForm`,
        downloadForm: `${environment.apiUrl}v1/dynamicForms/previewFormPdf`,
        addGalleryImages: `${environment.apiUrl}v1/opportunity/upsertGalleryContent`,
        deleteWorkOrderItem: `${environment.apiUrl}v1/opportunity/deleteWorkorder`,
        editPayment: `${environment.apiUrl}v1/opportunity/updatePayment`,
        previewEstimate: `${environment.apiUrl}v1/opportunity/previewEstimate`,
        assignOpp: `${environment.apiUrl}v1/opportunity/attachOpportunityToCustomer`,
        sharedFile: `${environment.apiUrl}v1/opportunity/shareFilesWithCustomer`,
        unShareFile: `${environment.apiUrl}v1/opportunity/unshareFilesWithCustomer`,
        approveInspection: `${environment.apiUrl}v1/opportunity/collectInspectionSignatures`,
        closeOpp: `${environment.apiUrl}v1/opportunity/closeOpportunity`,
        reopenOpp: `${environment.apiUrl}v1/opportunity/reopenOpportunity`,
        skipOpp: `${environment.apiUrl}v1/opportunity/skipEstimateVisit`,
        addInspectionSection: `${environment.apiUrl}v1/opportunity/addInspectionSection`,
        deleteInspectionItem: `${environment.apiUrl}v1/opportunity/deleteInspectionSection`,
        updateInspectionSection: `${environment.apiUrl}v1/opportunity/updateInspectionSection`
    },
    PAYMENT: {
        checkout: `${environment.apiUrl}v1/opportunity/checkout`,
        truckCharge: `${environment.apiUrl}v1/subscriptions/purchaseTrucks`,
        purchaseLimit: `${environment.apiUrl}v1/subscriptions/purchaseAdditionalUsageLimit`
    },
    SCRIPTING: {
        createFolder: `${environment.apiUrl}v1/scripts/createFolder`,
        getScripts: `${environment.apiUrl}v1/scripts/getScripts`,
        editScript: `${environment.apiUrl}v1/scripts/editScript`,
        getScriptList: `${environment.apiUrl}v1/scripts/getScriptList`,
        updateFolder: `${environment.apiUrl}v1/scripts/updateFolder`,
        deleteFolder: `${environment.apiUrl}v1/scripts/deleteFolder`,
        createScript: `${environment.apiUrl}v1/scripts/createScript`,
        deleteScript: `${environment.apiUrl}v1/scripts/deleteScript`,
        linkScript: `${environment.apiUrl}v1/scripts/linkScript`,
        scriptListForLink: `${environment.apiUrl}v1/scripts/scriptListForLink`,
        publishedScript: `${environment.apiUrl}v1/scripts/publishedScript`,
    },
    JOB: {
        getWorkorder: `${environment.apiUrl}v1/opportunity/getWorkOrders`,
    },
    CUSTOMER: {
        addCustomer: `${environment.apiUrl}v1/customers/inviteCustomer`,
        addCompanyCustomer: `${environment.apiUrl}v1/customers/inviteMultipleCustomer`,
        convertToCompany: `${environment.apiUrl}v1/customers/convertSimpleToCompany`,
        customerList: `${environment.apiUrl}v1/customers/customerList`,
        customerListBySearch: `${environment.apiUrl}v1/customers/customerBySearch`,
        editCustomer: `${environment.apiUrl}v1/customers/editCustomer`,
        deleteCustomer: `${environment.apiUrl}v1/customers/deleteCustomer`,
        hardDelete: `${environment.apiUrl}v1/customers/permanentDeleteCustomer`,
        getCustomerDetails: `${environment.apiUrl}v1/customers/customerDetail`,
        setHideDetailsOfCustomer: `${environment.apiUrl}v1/customers/setHideDetailsOfCustomer`,
        getHideDetailsOfCustomer: `${environment.apiUrl}v1/customers/getHideDetailsOfCustomer`,
        addNote: `${environment.apiUrl}v1/customers/addNotes`,
        editNote: `${environment.apiUrl}v1/customers/editNotes`,
        deleteNote: `${environment.apiUrl}v1/customers/deleteNotes`,
        addFiles: `${environment.apiUrl}v1/customers/addFiles`,
        deleteFile: `${environment.apiUrl}v1/customers/deleteFiles`,
        customerArchive: `${environment.apiUrl}v1/customers/CustomerListForArchive`,
        restoreCustomer: `${environment.apiUrl}v1/customers/restoreCustomer`,
        upload: `${environment.apiUrl}v1/customers/bulkUpload`,
        customerListForChat: `${environment.apiUrl}v1/customers/customerListForChat`,
        customerChatsList: `${environment.apiUrl}v1/customers/customerListForNotification`,
        getHistory: `${environment.apiUrl}v1/customers/activityLogs`,
        mergeCustomer: `${environment.apiUrl}v1/customers/mergeCustomer`,
        customerAddress: `${environment.apiUrl}v1/customers/nearestCompany`,
        exportCSV: `${environment.apiUrl}v1/customers/exportCustomersCsv`,
        convertCustomer: `${environment.apiUrl}v1/customers/convertCustomer`,
        pollingApi: `${environment.apiUrl}v1/customers/getJobStatus`,
        messages: `${environment.apiUrl}v1/customers/lastChatTime`,
        pinUnpinChat: `${environment.apiUrl}v1/customers/pinnedStatus`,
        initiateAiCall: `${environment.apiUrl}v1/events/aiOutboundCall`,
        customerQbSync: `${environment.apiUrl}v1/quickBook/syncCustomers`,
        importCSVList: `${environment.apiUrl}v1/customers/importHistory`,
        permaDelCustomer: `${environment.apiUrl}v1/customers/deleteCustomerFromArchive`,
        addGalleryImages: `${environment.apiUrl}v1/customers/addCustomerGallery`,
        muteCustomer: `${environment.apiUrl}v1/customers/givePortalAccess`,
        addPropertyImages: `${environment.apiUrl}v1/customers/addPropertyImages`
    },
    REPORT: {
        oppCount: `${environment.apiUrl}v1/dashboard/oppCount`,
        appointmentCount: `${environment.apiUrl}v1/dashboard/appointmentCount`,
        services: `${environment.apiUrl}v1/dashboard/serviceWithRevenue`,
        itemWithRevenue: `${environment.apiUrl}v1/dashboard/itemWithRevenue`,
        salesPerPerson: `${environment.apiUrl}v1/reporting/salesPerPerson`,
        totalSales: `${environment.apiUrl}v1/dashboard/totalSales`,
        amountApproved: `${environment.apiUrl}v1/dashboard/amountApproved`,
        actualRevenue: `${environment.apiUrl}v1/dashboard/actualRevenue`,
        estimateCount: `${environment.apiUrl}v1/dashboard/estimateCount`,
        limitAnalytics: `${environment.apiUrl}v1/dashboard/companyUsageSummary`
    },
    EVENTS: {
        myEvents: `${environment.apiUrl}v1/dashboard/myEvents`,
        createEvent: `${environment.apiUrl}v1/events/createEvent`,
        updateEvent: `${environment.apiUrl}v1/events/updateEvent`,
        deleteEvent: `${environment.apiUrl}v1/events/deleteEvent`,
        getEventsForCalendar: `${environment.apiUrl}v1/events/getEventsForCalendar`,
        getEventsForDispatch: `${environment.apiUrl}v1/events/getEmployeeEvent`,
        updateEventDescription: `${environment.apiUrl}v1/events/updateEventDescription`,
        totalEventsWithCount: `${environment.apiUrl}v1/dashboard/totalEventsWithCount`,
        updateEventDuration: `${environment.apiUrl}v1/events/updateEventDuration`,
        createGroupsForDispatch: `${environment.apiUrl}v1/employees/createDispatchGroup`,
        getAllGroup: `${environment.apiUrl}v1/employees/getAllGroups`,
        deleteDispatchGroup: `${environment.apiUrl}v1/employees/deleteDispatchGroup`,
        updateEventsDuration: `${environment.apiUrl}v1/events/updateEventDurationForCalendar`
    },
    DASHBOARD: {
        customerCount: `${environment.apiUrl}v1/dashboard/customerCount`,
        jobCount: `${environment.apiUrl}v1/dashboard/jobCount`,
        employeeCount: `${environment.apiUrl}v1/dashboard/employeeCount`,
        totalEvents: `${environment.apiUrl}v1/dashboard/totalEvents`,
        routing: `${environment.apiUrl}v1/dashboard/routing`,
        deleteTask: `${environment.apiUrl}v1/tasks/deleteTask`
    },
    SERVICE: {
        getServiceList: `${environment.apiUrl}v1/items/getItems?chargeType=Service`,
    },
    DESCRIPTION: {
        getDescriptionList: `${environment.apiUrl}v1/description/getDescription`,
        deleteDescription: `${environment.apiUrl}v1/description/deleteDescription`,
        createDescription: `${environment.apiUrl}v1/description/addDescription`,
    },
    SKILL: {
        getSkillsForService: `${environment.apiUrl}v1/skills/skillsForService`,
        getSkills: `${environment.apiUrl}v1/skills/skills`,
        deleteSkill: `${environment.apiUrl}v1/skills/delete`,
        addSkill: `${environment.apiUrl}v1/skills/create`,
    },
    SETTING: {
        getTimeSlots: `${environment.apiUrl}v1/setting/timeSlotSize`,
        timeSlotSize: `${environment.apiUrl}v1/setting/timeSlotSize`,
        settimeSlotSize: `${environment.apiUrl}v1/setting/settimeSlotSize`,
        setDistanceFormat: `${environment.apiUrl}v1/setting/setDistanceFormat`,
        getDistanceFormat: `${environment.apiUrl}v1/setting/getDistanceFormat`,
        getWeeksForTimeSlot: `${environment.apiUrl}v1/setting/getWeeksForTimeSlot`,
        setWeeksForTimeSlot: `${environment.apiUrl}v1/setting/setWeeksForTimeSlot`,
        setDailyGoal: `${environment.apiUrl}v1/setting/setDailyGoal`,
        getDailyGoal: `${environment.apiUrl}v1/setting/getDailyGoal`,
        getInspectionBtnStatus: `${environment.apiUrl}v1/inspection/inspections`,
        updateInspectionBtnStaus: `${environment.apiUrl}v1/inspection/updateInspections`,
        syncTimeAndFrequency: `${environment.apiUrl}v1/quickBook/qbSyncSetting`,
        getValorCreds: `${environment.apiUrl}v1/setting/CompanyValorAccount`,
        updateValorCreds: `${environment.apiUrl}v1/setting/valorAccount`,
        runPayCreds: `${environment.apiUrl}v1/setting/CompanyRunPaymentAccount`,
        updateRunPayCreds: `${environment.apiUrl}v1/setting/runPaymentAccount`
    },
    SCHEDULE: {
        scheduleEvent: `${environment.apiUrl}v1/opportunity/scheduleEvent`
    },
    ROLES: {
        getRoles: `${environment.apiUrl}v1/roles/roles`,
        createRole: `${environment.apiUrl}v1/roles/create`,
        deleteRole: `${environment.apiUrl}v1/roles/delete`,
        workingAddres: `${environment.apiUrl}v1/client/workingAddress`,
    },
    COACHING: {
        getFolders: `${environment.apiUrl}v1/videos/getFolders`,
        getVideos: `${environment.apiUrl}v1/videos/getVideos`,
        getVideoDetail: `${environment.apiUrl}v1/videos/getVideoById`,
        getFeeds: `${environment.apiUrl}v1/feeds/getFeedList`,
        addComment: `${environment.apiUrl}v1/commentLikes/addComment`,
        addLikes: `${environment.apiUrl}v1/commentLikes/addLikes`,
        unLike: `${environment.apiUrl}v1/commentLikes/unLikeData`,
        addViews: `${environment.apiUrl}v1/commentLikes/addViews`,
        saveVideo: `${environment.apiUrl}v1/videos/savedVideos`,
        getSavedVideos: `${environment.apiUrl}v1/videos/getSavedVideos`,
        getFeedDetail: `${environment.apiUrl}v1/feeds/getFeedById`,
        createFeedGroup: `${environment.apiUrl}v1/videos/createFolder`,
        getGroupList: `${environment.apiUrl}v1/videos/getFolders`,
        deleteGroup: `${environment.apiUrl}v1/videos/deleteFolder`,
        createFeed: `${environment.apiUrl}v1/feeds/createFeed`,
        deleteFeed: `${environment.apiUrl}v1/feeds/deleteFeed`,
        getFeedCount: `${environment.apiUrl}v1/notifications/updateNotificationSeen`,
        deleteComment: `${environment.apiUrl}v1/commentLikes/deleteComment`
    },
    ITEMS: {
        addItem: `${environment.apiUrl}v1/items/createItem`,
        getItems: `${environment.apiUrl}v1/items/getItems`,
        deleteItem: `${environment.apiUrl}v1/items/deleteItem`,
        createBundle: `${environment.apiUrl}v1/itemBundle/createBundle`,
        getBundles: `${environment.apiUrl}v1/itemBundle/getBundles`,
        deleteBundle: `${environment.apiUrl}v1/itemBundle/deleteBundle`,
        getItemsForBundle: `${environment.apiUrl}v1/items/getItemsForBundle`,
        updateBundleItems: `${environment.apiUrl}v1/itemBundle/updateBundleItem`,
        syncQuickbook: `${environment.apiUrl}v1/quickBook/connect`,
        syncQuickbookItems: `${environment.apiUrl}v1/quickBook/syncItems`,
        callback: `${environment.apiUrl}v1/quickBook/callback`,
        bulkImport: `${environment.apiUrl}v1/items/bulkImport`,
        syncQuickbookInovice: `${environment.apiUrl}v1/quickBook/syncInvoices`,
        duplicateItem: `${environment.apiUrl}v1/items/createDuplicateItem`,
        duplicateBundle: `${environment.apiUrl}v1/itemBundle/duplicateBundle`,
        updateIndex: `${environment.apiUrl}v1/itemBundle/reorderBundleItems`,
        setColumnHeaders: `${environment.apiUrl}v1/client/updateItemCatalogColumns`
    },
    SOURCE: {
        addSource: `${environment.apiUrl}v1/source/addSource`,
        getSource: `${environment.apiUrl}v1/source/getSourceList`,
        deleteSource: `${environment.apiUrl}v1/source/deleteSource`,
    },
    TAX: {
        addTax: `${environment.apiUrl}v1/tax/addTax`,
        getTax: `${environment.apiUrl}v1/tax/getTaxList`,
        deleteTax: `${environment.apiUrl}v1/tax/deleteTax`,
    },
    MEETING: {
        getMeetings: `${environment.apiUrl}v1/meetings/meetingList`,
        getSignature: `${environment.apiUrl}v1/meetings/verifySign`,
        updateStatus: `${environment.apiUrl}v1/meetings/updateMeetingStatus`
    },
    NOTIFICATION: {
        getCoachingNotifications: `${environment.apiUrl}v1/notifications/notifications`,
        clearAllNotifications: `${environment.apiUrl}v1/notifications/clearAllNotifications`,
        updateNotificationSeen: `${environment.apiUrl}v1/notifications/updateNotificationSeen`
    },
    LOGOUT: `${environment.apiUrl}v1/client/logout`,
    CLIENT: {
        createSubscription: `${environment.apiUrl}v1/subscriptions/createSubscription`,
        publicCreateSubscription: `${environment.apiUrl}v1/subscriptions/publicCreateSubscription`,
        subscriptionList: `${environment.apiUrl}v1/subscriptions/getSubscription`,
        getServiceList: `${environment.apiUrl}v1/client/services`,
        registerClient: `${environment.apiUrl}v1/client/invite`
    },
    SETTING_NOTIFICATION: {
        getNotification: `${environment.apiUrl}v1/settingNotifications/notifications`,
        create: `${environment.apiUrl}v1/settingNotifications/create`,
        logs: `${environment.apiUrl}v1/emailLogs/getEmailLogs`
    },
    REPORT_MODULE: {
        companySalesData: `${environment.apiUrl}v1/reporting/companySaleData`,
        jobRevenue: `${environment.apiUrl}v1/reporting/jobRevenue`,
        salesPerPerson: `${environment.apiUrl}v1/reporting/salesPerPerson`,
        salesProduction: `${environment.apiUrl}v1/reporting/salesProduction`,
        revenue: `${environment.apiUrl}v1/reporting/revenue`,
    },
    EMAIL: {
        getEMail: `${environment.apiUrl}v1/setting/getMasterEmail`,
        patchEMail: `${environment.apiUrl}v1/setting/updateMasterEmail`,
        updateEmailNotificationStatus: `${environment.apiUrl}v1/setting/verifyNotificationEmail`

    },
    FORMS: {
        addForm: `${environment.apiUrl}v1/dynamicForms/addForm`,
        editForm: `${environment.apiUrl}v1/dynamicForms/edit`,
        formList: `${environment.apiUrl}v1/dynamicForms/formList`,
        deleteFrom: `${environment.apiUrl}v1/dynamicForms/deleteForm`,
        getFormById: `${environment.apiUrl}v1/dynamicForms/getFormById`,
        downloadForm: `${environment.apiUrl}v1/dynamicForms/exportForm`,
        importForm: `${environment.apiUrl}v1/dynamicForms/importForm`,
    },
    Reminder: {
        editReminder: `${environment.apiUrl}v1/events/updateReminder `,
    },
    Campaign: {
        campaignList: `${environment.apiUrl}v1/campaign/campaignListing`,
        getList: `${environment.apiUrl}v1/campaign/populateCampaignFilter`,
        customerList: `${environment.apiUrl}v1/campaign/customerList`,
        createCampaign: `${environment.apiUrl}v1/campaign/createCampaign`,
        campaginDetail: `${environment.apiUrl}v1/campaign/campaignDetail`,
        campaginDelete: `${environment.apiUrl}v1/campaign/deleteCampaign`,
        testEmail: `${environment.apiUrl}v1/campaign/testMail`,
        importCSV: `${environment.apiUrl}v1/campaign/importCsv`




    },
    MESSAGE: {
        deleteGroup: `${environment.apiUrl}v1/client/removeGroup `
    },
    INVOICE: {
        getListing: `${environment.apiUrl}v1/client/invoiceList`
    },
    EMAILEDITOR: {
        addTemplate: `${environment.apiUrl}v1/template/addTemplate`,
        getTemplate: `${environment.apiUrl}v1/template/templateListing`,
        deleteTemplate: `${environment.apiUrl}v1/template/deleteTemplate`,
        getTemplateDetail: `${environment.apiUrl}v1/template/templateDetail`,


    },
    QUICKBOOK: {
        quickBooklist: `${environment.apiUrl}v1/quickbook/qbLogs`,
        quickBookDeactivate: `${environment.apiUrl}v1/quickbook/disconnectQbAccount`,
        quickBookReactivate: `${environment.apiUrl}v1/quickbook/reconnectQbAccount`,


    },
    AIAGENT: {
        callLogs: `${environment.apiUrl}v1/reporting/twilioCallLogs`,
        callCountAnalytics: `${environment.apiUrl}v1/reporting/aiAgentReport`,
        aiEventAnalytics: `${environment.apiUrl}v1/reporting/aiAgentEventGraph`,
        aiMinutesAnalytics: `${environment.apiUrl}v1/reporting/aiMinutesGraph`,
        getVoices: `${environment.apiUrl}v1/setting/getVoices`,
        getPersonalitySettings: `${environment.apiUrl}v1/setting/getAiSettings`,
        saveChanges: `${environment.apiUrl}v1/setting/updateAiSettings`,
        sampleVoice: `${environment.apiUrl}v1/setting/sampleVoice`,
        getBackgroundData: `${environment.apiUrl}v1/setting/getCompanyBackground`,
        saveBackgroundData: `${environment.apiUrl}v1/setting/updateCompanyBackground`,

        addDifferentiator: `${environment.apiUrl}v1/setting/addKeyDifferentiator`,
        editDifferentiator: `${environment.apiUrl}v1/setting/updateKeyDifferentiator`,
        deleteDifferentiator: `${environment.apiUrl}v1/setting/deleteKeyDifferentiator`,

        qnaList: `${environment.apiUrl}v1/setting/getQnaLibrary`,
        addQna: `${environment.apiUrl}v1/setting/addQnaItem`,
        updateQna: `${environment.apiUrl}v1/setting/updateQnaItem`,
        deleteQna: `${environment.apiUrl}v1/setting/deleteQnaItem`,

        getRules: `${environment.apiUrl}v1/setting/getCallHandlingRules`,
        deleteRule: `${environment.apiUrl}v1/setting/deleteCallHandlingRule`,
        addRule: `${environment.apiUrl}v1/setting/addCallHandlingRules`,
        editRule: `${environment.apiUrl}v1/setting/updateCallHandlingRules`,
        editRuleCheckList: `${environment.apiUrl}v1/setting/checklistItemUpdate`,

        getServices: `${environment.apiUrl}v1/setting/allServiceForAI`,
        updateQueries: `${environment.apiUrl}v1/setting/updateServiceQueries`,
        updateServiceEnable: `${environment.apiUrl}v1/setting/toggleServiceAI`,

        getControls: `${environment.apiUrl}v1/setting/getAiCallSettings`,
        updateControls: `${environment.apiUrl}v1/setting/updategetAiCallSettings`,
        changeStatus: `${environment.apiUrl}v1/reporting/changeCallStatus`
    },
    PACKAGES: {
        packagesList: `${environment.apiUrl}v1/subscriptions/getSubscriptionList`,
        clientPackage: `${environment.apiUrl}v1/subscriptions/getClientSubscriptionList`,
        proRatedPackage: `${environment.apiUrl}v1/subscriptions/getProratedAmount`,
        purchaseLimitData: `${environment.apiUrl}v1/subscriptions/addOnLimitPricing`
    },

    HELPSUPPORT: {
        createSupportTicekt: `${environment.apiUrl}v1/support/createSupportTicket`,
        ticketList: `${environment.apiUrl}v1/support/getSupportTicket`
    },
    GALLERY: {
        getGlobalGallery: `${environment.apiUrl}v1/client/companyGalleryContent`,
        getOppGallery: `${environment.apiUrl}v1/opportunity/galleryContent`,
        getTags: `${environment.apiUrl}v1/tags/tags`,
        editGallery: `${environment.apiUrl}v1/opportunity/updateGalleryContent`,
        addComment: `${environment.apiUrl}v1/opportunity/addCommentToGalleryMedia`,
        addCustomerComment: `${environment.apiUrl}v1/customers/addGalleryComment`,
        deleteComments: `${environment.apiUrl}v1/opportunity/deleteComment`,
        deleteCustomerComment: `${environment.apiUrl}v1/customers/deleteGalleryComment`,
        deleteMedia: `${environment.apiUrl}v1/opportunity/deleteGalleryMedia`,
        shareWithCustomer: `${environment.apiUrl}v1/opportunity/shareWithCustomer`,
        getCustomerData: `${environment.apiUrl}v1/customers/customerGallery`,
        updateCustomerGallery: `${environment.apiUrl}v1/customers/updateCustomerGallery`
    },
    TAGS: {
        createTags: `${environment.apiUrl}v1/tags/createTags`,
        deleteTags: `${environment.apiUrl}v1/tags/deleteTags`
    }
}